"use strict";

var _classCallCheck = require("/usr/src/app/www/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _createClass = require("/usr/src/app/www/node_modules/@babel/runtime/helpers/createClass.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RunnerIterator = void 0;

var RunExecution_1 = require("./reporter/RunExecution");

var RunnerIterator = /*#__PURE__*/function (_Symbol$iterator) {
  function RunnerIterator(sourceValues, shrink, verbose, interruptedAsFailure) {
    _classCallCheck(this, RunnerIterator);

    this.sourceValues = sourceValues;
    this.shrink = shrink;
    this.runExecution = new RunExecution_1.RunExecution(verbose, interruptedAsFailure);
    this.currentIdx = -1;
    this.nextValues = sourceValues;
  }

  _createClass(RunnerIterator, [{
    key: _Symbol$iterator,
    value: function value() {
      return this;
    }
  }, {
    key: "next",
    value: function next() {
      var nextValue = this.nextValues.next();

      if (nextValue.done || this.runExecution.interrupted) {
        return {
          done: true,
          value: undefined
        };
      }

      this.currentValue = nextValue.value;
      ++this.currentIdx;
      return {
        done: false,
        value: nextValue.value.value_
      };
    }
  }, {
    key: "handleResult",
    value: function handleResult(result) {
      if (result != null && typeof result === 'string') {
        this.runExecution.fail(this.currentValue.value_, this.currentIdx, result);
        this.currentIdx = -1;
        this.nextValues = this.shrink(this.currentValue);
      } else if (result != null) {
        if (!result.interruptExecution) {
          this.runExecution.skip(this.currentValue.value_);
          this.sourceValues.skippedOne();
        } else {
          this.runExecution.interrupt();
        }
      } else {
        this.runExecution.success(this.currentValue.value_);
      }
    }
  }]);

  return RunnerIterator;
}(Symbol.iterator);

exports.RunnerIterator = RunnerIterator;